export enum EInternalEmails {
	SUPPORT = 'support@affilead.ru',
}
